"use client";
import { useReducer } from 'react';
import { initState, appReducer, APP_ACTION_TYPES } from '@/store';

const useStore = () => {
  const [store, dispatch] = useReducer(appReducer, initState);
  return [store, dispatch];
};

export { APP_ACTION_TYPES };

export default useStore;
